import TimelineComponent from './component';

interface TimelineItem {
  comment: string;
  created_at: string;
}

interface TimelineProps {
  timeline: TimelineItem[];
}

const Timeline = ({timeline}: TimelineProps) => {
  return <TimelineComponent timeline={timeline} />;
};

export default Timeline;
